module.exports = __webpack_public_path__ + "img/potassium-offline.4a8c3a74.svg";